import { useFormatDate, useOpen } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { SelfTravelEditDrawer } from "../../../../../../shared/SelfTravelDrawer";
import { GuestSelfTravelResource } from "../../../../../../shared/types/selfTravel";
import { TravelDirection } from "../../../../shared/types/travelSegment";
import { CardBody, CardHeader, TravelCard } from "./Card";
import { LabeledValue } from "./LabeledValue";

interface Props {
	selfTravel: GuestSelfTravelResource;
	onRemove: () => void;
	isRemarksFieldRequired: boolean;
	onEditSelfTravel: (selfTravel: GuestSelfTravelResource) => void;
	direction: TravelDirection;
}

export const SelfTravelCard: FC<Props> = ({
	selfTravel,
	onRemove,
	onEditSelfTravel,
	isRemarksFieldRequired,
	direction,
}) => {
	const { t } = useTranslation();
	const formatDate = useFormatDate();
	const { open, handleOpen, handleClose } = useOpen();
	return (
		<>
			<TravelCard>
				<CardHeader onRemove={onRemove} onEdit={handleOpen}>
					{t("Self travel")}
				</CardHeader>
				<CardBody>
					<LabeledValue label={direction === "arrival" ? t("Arrival time") : t("Departure time")}>
						{formatDate(selfTravel.date)} {selfTravel.time}
					</LabeledValue>
				</CardBody>
				{selfTravel.remarks && <LabeledValue label={t("Remarks")}>{selfTravel.remarks}</LabeledValue>}
			</TravelCard>
			<SelfTravelEditDrawer
				open={open}
				selfTravel={selfTravel}
				onSubmit={onEditSelfTravel}
				handleClose={handleClose}
				isRemarksFieldRequired={isRemarksFieldRequired}
				direction={direction}
			/>
		</>
	);
};
